// import { useEffect, useCallback } from 'react';
import { Button, CircularProgress } from "@mui/material"
import LaudoVisita from "entity/LaudoVisita"
// import { getColDataCustomForm } from 'entity/dbApiForms'
import _ from 'lodash'

export default function CSVButton({ /*startDate = '20230630', endDate = '20230630',*/ laudos = [], globalLoading = '', setGlobalLoading }) {
    const gerarArquivo = (texto, nome) => {

        let fileBlob = new Blob(["\ufeff", texto])
        if (window.cordova) {
            document.addEventListener("deviceready", function () {
                var storageLocation = ""
                console.log('window.cordova', window.cordova)
                storageLocation = window.cordova.file.dataDirectory

                var folderPath = storageLocation
                console.log('folderPath', folderPath)
                console.log('nome', nome)
                window.resolveLocalFileSystemURL(
                    folderPath,
                    function (dir) {
                        console.log("Access to the directory granted succesfully", dir)
                        dir.getFile(
                            nome,
                            {
                                create: true
                            },
                            function (file) {
                                console.log('file', file)
                                file.createWriter(
                                    function (fileWriter) {
                                        fileWriter.write(fileBlob)

                                        fileWriter.onwriteend = function () {
                                            var url = file.toURL()
                                            console.log('url', url)
                                            window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                                error: function error(err) {
                                                    console.error(err)
                                                    alert("Unable to download3")
                                                },
                                                success: function success() {
                                                    console.log("success with opening the file")
                                                }
                                            })
                                        }

                                        fileWriter.onerror = function (err) {
                                            alert("Unable to download2")
                                            console.error(err)
                                        }
                                    },
                                    function (err) {
                                        // failed
                                        alert("Unable to download")
                                        console.error('err', err)
                                    }
                                )
                            },
                            function (err) {
                                alert("Unable to download")
                                console.error(err)
                            }
                        )
                    },
                    function (err) {
                        alert("Unable to download")
                        console.error(err)
                    }
                )
            })
        } else {
            var element = document.createElement("a")
            element.href = URL.createObjectURL(fileBlob)
            element.download = nome
            element.click()
        }
        setGlobalLoading("")
    }

    const createCSVContent = (list, conf) => {
        let strCsv = ''
        let separator = ';'
        conf.forEach(c => {
            strCsv += c.labelCol + separator
        })
        strCsv += '\n'

        list.forEach(l => {
            conf.forEach(c => {
                let v = ""
                if (_.isString(c.getValue)) {
                    v = _.get(l, c.getValue)
                    if (v) {
                        v = '"' + v + '"'
                    }
                } else {
                    v = c.getValue(l)
                }
                if (!v) {
                    v = ''
                }
                strCsv += v + separator
            })
            strCsv += '\n'
        })

        gerarArquivo(strCsv, `ExportarCSVTCH.csv`)
    }

    const exportarCSV = (list, columns) => {
        let conf = columns

        if (list.length) {
            createCSVContent(list, conf)
        } else {
            console.log("Lista vazia p/ criação de CSV")
        }
    }

    const estatisticaCSV = async (list) => {
        setGlobalLoading("Buscando Laudos")
        exportarCSV(list, LaudoVisita.csvColumns)
    }

    return (
        <Button
            variant='contained'
            color='primary'
            disabled={globalLoading.length ? true : false}
            onClick={async () => await estatisticaCSV(laudos)}
        >
            {globalLoading.length ? <CircularProgress /> : 'Gerar CSV'}
        </Button>
    )
}